import { useEffect, useState } from 'react';
import ValidatedInput, { ValidatedState } from '../../components/custom-input/ValidatedInput';
import { Validators } from '../../types/enums';
import { StorageSite, StorageTank } from '../../types/interfaces';
import { createStorageCanister } from '../../api/storageItemsApi';
import { showToast } from '../../services/toast.service';
import { toastMessages } from '../../constants/errorMessages';
import './locationManagement.scss';

type AddCanisterModalProps = {
  close: () => void;
  site: StorageSite;
  tank: StorageTank;
  setSelectedId: (id: number) => void;
};

const AddCanisterModal = ({ close, site, tank, setSelectedId }: AddCanisterModalProps): JSX.Element => {
  const [nameInput, setNameInput] = useState<ValidatedState>({ valid: false, value: '' });
  const [activeInput, setActiveInput] = useState<boolean>(true);
  const [validate, setValidate] = useState<boolean>(false);
  const [submit, setSubmit] = useState<boolean>(false);

  useEffect(() => {
    const action = async () => {
      try {
        const { data: id } = await createStorageCanister({
          name: nameInput.value,
          active: activeInput,
          storageTankId: tank.storageTankId,
        });
        setSelectedId(id);
        showToast.success(toastMessages.CANISTER_CREATED_SUCCESS);
      } catch {
        showToast.success(toastMessages.CANISTER_CREATED_FAIL);
      } finally {
        setSubmit(false);
        close();
      }
    };
    if (submit) {
      action();
    }
  }, [submit]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setValidate(true);
    if (nameInput.valid) {
      setSubmit(true);
    }
  };

  return (
    <div className="management-columns-modal">
      <form onSubmit={handleSubmit}>
        <h2>Add Canister</h2>
        <p>Please complete the form to add a new canister.</p>
        <div className="form-row">
          <label>Site Name:</label>
          <div className="input-container">
            <label>{site.name}</label>
          </div>
        </div>
        <div className="form-row">
          <label>Tank Name:</label>
          <div className="input-container">
            <label>{tank.name}</label>
          </div>
        </div>
        <ValidatedInput
          useId="name-input-field"
          type="text"
          label={'Canister Name'}
          validate={validate}
          setValidatedState={setNameInput}
          validators={[Validators.REQUIRED]}
        />
        <div className="form-row">
          <label htmlFor="active-checkbox">Active</label>
          <div className="input-container">
            <input
              id="active-checkbox"
              type="checkbox"
              defaultChecked={activeInput}
              onChange={e => setActiveInput(e.target.checked)}
            />
          </div>
        </div>
        <div className="flex-right submit-button">
          <button type="button" className="small green inverted button" onClick={close}>
            Cancel
          </button>
          &emsp;
          <button type="submit" className={nameInput.valid ? 'small green button' : 'small green button disabled'}>
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddCanisterModal;
